<script lang="ts" setup>
import { ToccoEventItem } from '~/api/drupal'
import { normalizeDurationDays } from '~/lib/utils/toccoUtils'

const props = defineProps<{
  item: ToccoEventItem
  dim?: boolean
}>()

const { t } = useI18n()

const duration = computed(() => {
  const durationDays = normalizeDurationDays(props.item.durationDays)
  return durationDays ? t('tocco.durationDays', durationDays) : props.item.duration
})
</script>

<template>
  <LinkListLargeItem :dim="!!dim" :link="{ url: item.url, text: item.title }">
    <h3 class="title text-medium">{{ item.title }}</h3>
    <div class="type">
      <span class="label">{{ item.type }}</span>
      <span v-if="duration" class="duration text-small">{{ duration }}</span>
    </div>
    <span v-if="item.teaser" class="teaser text-xsmall f-medium">{{ item.teaser }}</span>
    <span v-else />
  </LinkListLargeItem>
</template>

<style lang="scss" scoped>
.item.item {
  @include breakpoint(ts) {
    grid-template-columns: auto 1fr;
  }
  // Artboard columns: 560 title / 263 details / 263 series / 60 arrow, 16px gaps.
  @include breakpoint(tl) {
    grid-template-columns: 560fr 263fr 263fr auto;
    gap: 16px;
  }

  :deep(.button) {
    justify-self: end;
    @include breakpoint(ts) {
      grid-column: 2;
    }
    @include breakpoint(tl) {
      grid-column: auto;
    }
  }
}

.title {
  margin-bottom: 0;
  color: var(--c-primary);

  @include breakpoint(ts) {
    grid-column: 1 / span 2;
  }
  @include breakpoint(tl) {
    grid-column: 1 / span 1;
  }
}

.type {
  display: flex;
  flex-direction: column;

  .label {
    color: var(--c-primary);
  }

  .duration {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}

.teaser {
  display: block;
  box-sizing: border-box;
  justify-self: start;
  max-width: 100%;
  padding: 8px 12px;

  border: 1px solid rgba(var(--c-blue-100-rgb), 0.25);

  color: var(--c-primary);
  overflow-wrap: anywhere;

  @include breakpoint(tl) {
    justify-self: stretch;
  }
}
</style>
